import { helpers } from '@vuelidate/validators';

/**
 * Converts API response to more readable slots. Example:
 * [
 *      {
 *          date: "lundi 04 déc.",
 *          slots: [
 *              {
 *                  id: "timeslot-0-0",
 *                  text: "10h",
 *                  disabled: true,
 *                  value: null
 *              },
 *          ],
 *     },
 * ]
 */
export function convertApiResponseToSlots (slots_available) {
    if (!slots_available) return [];

    const daySlots = [];

    let dayIndex = 0;

    for (let [dayKey, hourSlots] of Object.entries(slots_available)) {
        const daySlot = {date: dayKey, slots: []}

        let hourIndex = 0;
        for (let [hourKey, hourSlot] of Object.entries(hourSlots)) {
            const id = `timeslot-${dayIndex}-${hourIndex}`;
            const text = transformTimeRange(hourKey);
            const disabled = hourSlot ? false : true;
            const value = hourSlot ? hourSlot.from_timestamp : null;
            const system_user_id = hourSlot ? hourSlot.system_user_id : null;

            daySlot.slots.push({
                id,
                text,
                disabled,
                value,
                system_user_id,
            })
            hourIndex++
        }

        if (daySlot.slots.length > 0) daySlots.push(daySlot);
        dayIndex++
    }

    return daySlots;
}

export function transformTimeRange(timeRange) {
    // Séparer les heures de début et de fin
    const [startTime, endTime] = timeRange.split('-');

    return transformTime(startTime);
}

export function transformTime(time) {
    let [hours, minutes] = time.split(':');
    minutes = minutes.replace('h00', 'h');
    return minutes === '00' ? `${parseInt(hours)}h` : `${parseInt(hours)}h${minutes}`;
}

export const isValidEmail = helpers.regex(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
export const isValidPhoneNumber = helpers.regex(/^(\+33|0033|0)(6|7)[0-9]{8}$/);
export const isValidFirstName = helpers.regex(/^[a-zA-Zàâäéèêëïîôöùûüÿç\s\-]{2,}$/);
export const isValidLastName = helpers.regex(/^[a-zA-Z\s\-]{2,}$/);
export const hasNoAccents = helpers.regex(/^[^àâäéèêëïîôöùûüÿç]+$/);
